/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Integrate_Status_LabelInputs */

const en_directory_integrate_status_label = /** @type {(inputs: Directory_Integrate_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Availability status`)
};

const zh_directory_integrate_status_label = /** @type {(inputs: Directory_Integrate_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用状态`)
};

/**
* | output |
* | --- |
* | "Availability status" |
*
* @param {Directory_Integrate_Status_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_integrate_status_label = /** @type {((inputs?: Directory_Integrate_Status_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Integrate_Status_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_integrate_status_label(inputs)
	return zh_directory_integrate_status_label(inputs)
});
export { directory_integrate_status_label as "directory.integrate.status_label" }